import { Link } from "react-router-dom";
import { Gift, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-card/80 backdrop-blur-sm border-b sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <Gift className="w-8 h-8 text-primary" strokeWidth={1.5} />
            <span className="font-heading text-xl font-bold text-primary">GiftMe</span>
          </Link>
          <Button 
            variant="outline" 
            size="sm"
            className="rounded-full"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </Button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="font-heading text-3xl md:text-4xl font-bold mb-8">
          Politique de confidentialité
        </h1>
        
        <div className="prose prose-slate max-w-none space-y-6">
          <p className="text-muted-foreground text-lg">
            Dernière mise à jour : Décembre 2025
          </p>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">1. Données collectées</h2>
            <p className="text-muted-foreground leading-relaxed">
              GiftMe collecte uniquement les données nécessaires au bon fonctionnement du service :
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Votre adresse e-mail (pour la création de compte et la connexion)</li>
              <li>Votre nom et prénom (pour personnaliser votre expérience)</li>
              <li>Les informations de votre liste de souhaits (cadeaux, catégories, priorités)</li>
              <li>Votre nom d'utilisateur (pour le partage de votre liste)</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">2. Utilisation des données</h2>
            <p className="text-muted-foreground leading-relaxed">
              Vos données sont utilisées exclusivement pour :
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Vous permettre de créer et gérer votre liste de souhaits</li>
              <li>Permettre à vos proches de consulter et réserver des cadeaux</li>
              <li>Vous authentifier sur la plateforme</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">3. Protection des données</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nous nous engageons à protéger vos données personnelles. Vos informations sont stockées 
              de manière sécurisée et ne sont pas revendues à des tiers à des fins commerciales ou publicitaires.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Nous nous réservons le droit d'utiliser des données agrégées et anonymisées à des fins 
              d'études de marché et d'analyses statistiques. Ces données ne permettent en aucun cas 
              de vous identifier personnellement.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">4. Vos droits</h2>
            <p className="text-muted-foreground leading-relaxed">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li><strong>Droit d'accès</strong> : vous pouvez demander une copie de vos données personnelles</li>
              <li><strong>Droit de rectification</strong> : vous pouvez modifier vos informations depuis votre profil</li>
              <li><strong>Droit à l'effacement</strong> : vous pouvez demander la suppression de votre compte et de toutes vos données</li>
              <li><strong>Droit à la portabilité</strong> : vous pouvez demander l'export de vos données</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">5. Suppression des données</h2>
            <p className="text-muted-foreground leading-relaxed">
              Pour demander la suppression de vos données personnelles, vous pouvez :
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Supprimer votre compte directement depuis les paramètres de votre profil</li>
              <li>Nous contacter par e-mail pour toute demande spécifique</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed">
              Votre demande sera traitée dans un délai maximum de 30 jours.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">6. Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              GiftMe utilise uniquement des cookies essentiels au fonctionnement du service 
              (authentification, session). Nous n'utilisons pas de cookies publicitaires ou de tracking.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="font-heading text-xl font-bold">7. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              Pour toute question concernant cette politique de confidentialité ou vos données personnelles, 
              vous pouvez nous contacter à l'adresse : <strong>contact@giftme.app</strong>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t mt-16">
        <div className="max-w-4xl mx-auto px-6 py-6 text-center text-sm text-muted-foreground">
          © 2025 GiftMe. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
}
